
/*

DomScan


Last edited 02.07.17 by David Robbins

Specify selector or container to activate element code.

Can be housed within addContainer...
Example:

window.SETTINGS.domScan.addContainer($('#header-wrapper'), ($scanContainer) => {
	window.SETTINGS.domScan.addElement($scanContainer, [data-my-module], () => {
		// do stuff
	});
});

Or independently specified...
Example:

window.SETTINGS.domScan.addElement($('#element-wrapper'), [data-my-module], () => {
	// do stuff
});


*/

let Vent = require('./vent.js');

let instance = null; // singleton pt. 1/3

class DomScan {

	constructor(){

		// singleton pt. 2/3
		// is only called by first instance

		if(!instance){
			instance = this;
			this.init();
		}

		// singleton pt. 3/3

		return instance;
	}

	init(){

		if(!window.vent){
			window.vent = new Vent();
		}
	}

	// public methods

	addContainer($scanContainer, callback, subCats){

		// register a container that may contain mods at some point
		// allows for faster, more specific scans than if everything were in $('.body')

		let onDomUpdate = ((e, obj) => {
			$scanContainer = this._validateScanContainer($scanContainer);
			callback.apply(null, [$scanContainer]);
		});

		let eventName = 'domUpdate' + (subCats ? ':' + subCats.trim() : '');
		window.vent.on(eventName, onDomUpdate, this);

		onDomUpdate();
	};

	addElement($scanContainer, selector, callback, subCats){

		$scanContainer = this._validateScanContainer($scanContainer);
		$scanContainer.find(selector).each(function(){

			let $this = $(this);

			if ( !$this.data('ds-initialized') || $this.data('ds-initialized').indexOf(selector) < 0) {

				if(!$this.data('ds-initialized')){
					$this.data('ds-initialized', []);
				}

				if($this.data('auto-init') !== false){
					$this.data('ds-initialized').push(selector);
					callback.apply($this);
				}
			}
		});
	};

	// private

	_validateScanContainer($scanContainer){

		if ( typeof($scanContainer) === 'undefined' || !$scanContainer ) {
			$scanContainer = $('body');
		}

		if(!$scanContainer instanceof jQuery){
			$scanContainer = $($scanContainer);
		}

		return $scanContainer;
	};
}

module.exports = DomScan;
